// Module
var code = " <div class=\"col-lg-8\"> <h3>{{subject}}</h3> <p class=\"date\"><span [innerHTML]=\"msgTime\"></span> &nbsp;|&nbsp; <strong>Posted by:</strong>{{fromUser}} &nbsp;|&nbsp; <strong>Category:</strong>{{category}}</p> <p class=\"descrip\" [innerHTML]=\"body\"></p> </div> ";
// Exports
export default code;